<template>
	<div class="xx-editor">
		<quillEditor class="editor" :options="editorOption" :content="value" @change="onEditorChange($event)"
			ref="xxQuillEditor" />
		<input style="display:none;" type="file" id="imgFile" class="fileInput" ref="fileInput" multiple="multiple"
			@change="fileChange($event.target.files)" accept="image/*" />
	</div>
</template>

<script>
import axios from 'axios'
import { getOssMsg } from '@/api/oss'
import OSS from 'ali-oss'
import { quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
axios.defaults.headers.common['Content-Type'] =
	'application/x-www-form-urlencoded'
axios.defaults.headers.common['Accept'] = '*/*'
// const axiosInstance = axios.create({ withCredentials: false })
// 工具栏配置
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // toggled buttons
	['blockquote', 'code-block'],

	[{ header: 1 }, { header: 2 }], // custom button values
	[{ list: 'ordered' }, { list: 'bullet' }],
	[{ script: 'sub' }, { script: 'super' }], // superscript/subscript
	[{ indent: '-1' }, { indent: '+1' }], // outdent/indent
	[{ direction: 'rtl' }], // text direction

	[{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
	[{ header: [1, 2, 3, 4, 5, 6, false] }],

	[{ color: [] }, { background: [] }], // dropdown with defaults from theme
	[{ font: [] }],
	[{ align: [] }],
	['link', 'image'],
	['clean'] // remove formatting button
]
export default {
	components: {
		quillEditor
	},
	computed: {
		editor() {
			return this.$refs.xxQuillEditor.quill
		}
	},
	props: ['value', 'folder'],
	data() {
		return {
			content: '',
			editorOption: {
				placeholder: '请输入',
				theme: 'snow', // or 'bubble'
				modules: {
					toolbar: {
						container: toolbarOptions, // 工具栏
						handlers: {
							image: function (value) {
								if (value) {
									document.getElementById('imgFile').click()
								} else {
									this.quill.format('image', false)
								}
							}
						}
					}
				}
			}
		}
	},
	
	methods: {
		onEditorChange(event) {
			// console.log('Editor value:', this.value)
			this.$emit('input', event.html)
		},
		random_string(len) {
			len = len || 32
			var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
			var maxPos = chars.length
			var pwd = ''
			for (let i = 0; i < len; i++) {
				pwd += chars.charAt(Math.floor(Math.random() * maxPos))
			}
			return pwd
		},
		itemFilechang(file) {
			return new Promise(resolve => {

				if (file.size < 102400) {
					const fileName = file.name
					const suffix = fileName
						.substring(fileName.lastIndexOf('.') + 1)
						.toLowerCase()
					if (
						suffix === 'bmp' ||
						suffix === 'jpg' ||
						suffix === 'jpeg' ||
						suffix === 'png' ||
						suffix === 'gif'
					) {
						getOssMsg().then(res => {
							const config = {
								accessKeyId: res.access_key_id,
								accessKeySecret: res.access_key_secret,
								stsToken: res.security_token,
								bucket: res.bucket,
								region: res.region
							}
							return new Promise(() => {
								const fileName = `supply/goods_content/${this.folder
									}/${this.random_string(10)}.jpg`
								let client = new OSS(config)
								client
									.multipartUpload(fileName, file, {
										callback: {
											url: res.callback_url,
											host: res.callback_host,
											/* eslint no-template-curly-in-string: [0] */
											body: 'bucket=${bucket}&object=${object}&var1=${x:var1}',
											contentType: 'application/x-www-form-urlencoded',
											customValue: {
												var1: 'value1',
												var2: 'value2'
											}
										}
									})
									.then(results => {
										this.loading = false
										const url = `https://${res.cdn_domain}/${results.name}${suffix === ('jpg' || 'jpeg')
											? '?x-oss-process=image/quality,Q_40'
											: ''
											}`
										// 插入链接
										let quill = this.editor
										let length = quill.getSelection().index
										// 插入图片
										quill.insertEmbed(length, 'image', url)
										// 调整光标到最后
										quill.setSelection(length + 1)
										resolve(1)
									})
									.catch(() => {
										//上传失败
										this.loading = false
										this.$message.error('上传失败，请重新上传！')
										this.$refs.fileInput.value = ''
									})
							})
						})
					} else {
						this.$message.error('文件类型不正确,请重新上传！')
						resolve(1)
					}
				} else {
					this.$message.error('图片大小超过100kb,请重新上传')
					resolve(1)
				}
			})
		},
		async fileChange(file) {
			if (file && file.length) {
				const loading = this.$loading({
					lock: true,
					text: '上传中。。',
					background: 'rgba(255, 255, 255, 0.7)'
				})
				for (let i = 0; i < file.length; i++) {
					await this.itemFilechang(file[i])
				}
				loading.close()
			}
		}
	}
}
</script>

<style lang="scss">
.xx-editor {
	line-height: 1.5;
	text-align: left;
}

.ql-container {
	min-height: 300px;
}
</style>
